export const SAVE = 'modules/user/SAVE';
export const LHSAVE = 'modules/user/LHSAVE';
export const GUIDE = 'modules/user/GUIDE';
export const POINT = 'modules/user/POINT';
